"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f450 = void 0;
exports.f450 = {
    "ǂungkue": [
        2673
    ],
    "ǂ’amkhoe": [
        3073
    ],
    "ǂhua": [
        3073
    ],
    "ǂʼamkhoe": [
        3073
    ]
};
